export const SEARCH_AGAIN_BUTTON = "Search again";
export const GO_BACK_BUTTON = "Go back";
export const SHOP_ERROR_TITLE =
  "Uh oh! We were unable to process your shop request.";
export const SHOP_ERROR_SUBTITLE = "Something went wrong.";
export const BACK_TO_RESULTS_BUTTON = "Back to results";

export const UNAVAILABLE_DATE_ERROR_TITLE =
  "This experience is unavailable for selected date.";
export const UNAVAILABLE_DATE_ERROR_SUBTITLE = "Please select another date.";
export const OK_BUTTON = "Ok";
